import { render } from "./DurationInput.vue?vue&type=template&id=bcb0b508"
import script from "./DurationInput.vue?vue&type=script&lang=js"
export * from "./DurationInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__